<template>
  <div>
    <answer-render ref="answer" :config="config">
      <div slot="body" class="sort-wrap">
        <div class="qu-tip" v-if="!validFlg && config.answerConfig.maxAnswerNum">
          <span class="text">{{cvtLang('tipsMaxSort', config.tipsMaxSort).replace('${n}', maxSortNum)}}</span>
        </div>
        <FormItem prop="value" :rules="rules">
          <div :id="`sort-${config.id}`" class="option-list">
            <transition-group name="flip-list" tag="div">
              <div v-for="option in config.optionList" :key="option.id">
                <div v-if="option.visibility" :class="[option.value !== 0 ? 'sorted' : '', isMaxSorted && option.value === 0 ? 'disabled' : '']" class="item" @click="onSort(option)">
                  <div class="left">
                    <span class="sort-num">{{ option.value !== 0 ? option.value : '' }}</span>
                  </div>
                  <div class="right">
                    <span class="text option-style" v-html="option.displayTitle"></span>
                    <div v-if="option.imgUrl">
                      <ipsos-av v-if="isAv(option.imgUrl)" :src="option.imgUrl"></ipsos-av>
                      <ipsos-image v-else :imgUrl="option.imgUrl" :preview="option.id"></ipsos-image>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
import { mapState } from 'vuex'
export default {
  name: 'SortBoxAnswer',
  props: ['config'],
  data () {
    return {
      validFlg: false,
      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              this.validFlg = true
              return callback(errors)
            } else {
              setTimeout(() => {
                this.validFlg = false
              }, 100)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      langMap: ({Question}) => Question.langMap,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      surveyStyle: ({ Question }) => Question.surveyStyle
    }),
    maxSortNum () {
      const { config: { answerConfig: { maxAnswerNum }, optionList } } = this
      if (!maxAnswerNum) {
        return optionList.length
      } else {
        return maxAnswerNum
      }
    },
    isMaxSorted () {
      const maxSortNum = this.maxSortNum
      return maxSortNum === 0 ? false : this.config.optionList.filter(item => item.value !== 0).length >= maxSortNum
    }
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    onSort (item) {
      const isMaxSorted = this.isMaxSorted
      if (isMaxSorted && item.value === 0) {
        return
      }

      const sortEl = document.getElementById('sort-' + this.config.id)
      if (sortEl.nextElementSibling && sortEl.nextElementSibling.className === 'ivu-form-item-error-tip') {
        sortEl.nextElementSibling.style.display = 'none'
      }

      item.value = this.getMaxValue(item)
      this.updateValue()
    },
    updateValue () {
      const config = this.config
      const optionList = config.optionList.filter(item => item.value !== 0)
      config.value = optionList
        .reduce((pre, item) => {
          pre.push(item)
          return pre
        }, [])
        .sort((a, b) => a.value - b.value)
        .reduce((pre, item) => {
          pre.push(item.orderById)
          return pre
        }, [])
      config.optionList.sort((a, b) => {
        if (a.value < b.value) {
          return -1
        }
        return 1
      })
      const zeroOptions = config.optionList.filter(item => item.value === 0)
      if (zeroOptions.length) {
        config.optionList.splice(0, zeroOptions.length)
        config.optionList.push(...zeroOptions)
      }
    },
    getMaxValue (item) {
      const value = item.value
      const isNewNum = value === 0
      var maxValue = 0
      const optionList = this.config.optionList
      if (isNewNum) {
        var maxItem = optionList.reduce((a, b) => (a.value > b.value ? a : b))
        maxValue = maxItem.value
        maxValue = maxValue === 0 ? 1 : maxValue + 1
      } else {
        optionList.forEach(item => {
          const itemValue = item.value
          if (itemValue && itemValue > value) {
            item.value -= 1
          }
        })
      }
      return maxValue
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    }
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.sort-wrap {
  margin-top: 15px;
  .flip-list-move {
    transition: transform 0.6s;
  }
  .qu-tip {
    font-size: 28px;
    color: #808695;
  }
  .option-list {
    margin-top: 5px;
    .item {
      border-bottom: 2px solid #F1F1F1;
      color: #707070;
      padding: 18px 0;
      position: relative;
      background: #fff;
      display: flex;
      align-items: center;
      .left {
        margin-right: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        .sort-num {
          color: #707070;
          width: 36px;
          height: 36px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2px solid #dde5ed;
          border-radius: 50%;
          font-size: 24px;
        }
      }
      img {
        max-width: 100%;
      }
      .right {
        display: flex;
        flex-direction: column;
        flex: 1;
        font-size: 32px;
        color: #000;
        .av-wrap {
          width: 100% !important;
        }
        >>> .video-js {
          width: 100% !important;
          height: 250px !important;
        }
      }
      &.disabled {
        color: #d8d8d8;
        .left {
          .sort-num {
            border-color: #f1f1f1;
            background-color: #f1f1f1;
          }
        }
        .right {
          color: #999;
        }
      }
      &.sorted {
        .left {
          .sort-num {
            border-color: #4CBAA2;
            background-color: #4CBAA2;
            font-size: 24px;
            color: #fff;
          }
        }
      }
    }
  }
}
.answer-pc {
  .sort-wrap {
    margin-top: 0px;
    .qu-tip {
      font-size: 14px;
      color: #808695;
    }
    .option-list {
      margin-top: 5px;
      .item {
        border-bottom: none;
        padding: 9px 0;
        .left {
          margin-right: 8px;
          .sort-num {
            width: 18px;
            height: 18px;
            display: flex;
            border-width: 1px;
            font-size: 12px;
          }
        }
        .right {
          font-size: 16px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/editor/SortBox/SortBoxAnswer.vue